const moment = require('moment')

/**
 * Given a due date for a payment, return a class 
 * that can be used to style an HTML element.
 * @param {string} due A payment due date.
 * @returns A CSS class that can be used to style and HTML element.
 */
const ago = (due) => {
    if (!due) {
        return ''
    }

    const today = moment().startOf('day')
    const days = moment(due).startOf('day').diff(today, 'days')

    if (days < 0) {
        return 'past'
    }

    if (days === 0) {
        return 'today'
    }

    if ((days > 0) && (days <= 7)) {
        return 'soon'
    }

    return ''
}

/**
 * Given a due date for a payment, return a the number of 
 * days from today the payment is past due.
 * @param {string} due A payment due date.
 * @returns The number of days the payment is past due, if any.
 */
const daysAgo = (due) => {
    if (!due) {
        return 0
    }

    const today = moment().startOf('day')
    const days = moment(due).startOf('day').diff(today, 'days')

    if (days >= 0) {
        return 0
    }

    return (days * -1)
}

module.exports = {
    daysAgo,
    ago
}